import { useEffect } from 'react'
import { FormikProps } from 'formik'

export function useScrollToFormikError<T>(form: FormikProps<T>) {
  useEffect(() => {
    if (!form.isSubmitting) return
    if (Object.keys(form.errors).length > 0) {
      document.querySelector('.Mui-error')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }, [form])
}
